import http from "./index"
function getData(params) {
    return http.post('/article/where', params)
}
function getBannerList(params) {
    return http.post('/home/kingname/getKingBanner', params)
}

//获取太保广告列表
function getTbData(params) {
    return http.get('/TaiBaoNews?id=' + params.id, params)
}


export default {
    getTbData,
    getData,
    getBannerList
}


// WEBPACK FOOTER //
// ./src/api/api.js